module.exports = __webpack_public_path__ + "static/img/animales_18.5618c215.jpg";